import * as React from 'react';
import classNames from 'classnames';
import {Flex} from '../Flex';
import {Label} from '../Label';
import {Text} from '../Text';
import style from './text-area.scss';

export interface TextAreaProps {
  label?: string;
  value: string;
  error?: string;
  helpText?: string;
  touched?: boolean;
}

type InputProps = JSX.IntrinsicElements['textarea'];

export function TextArea({
  id,
  label,
  value,
  error,
  touched = false,
  helpText,
  className,
  ...restProps
}: TextAreaProps & InputProps) {
  const showHelp = Boolean(helpText);
  const showError = Boolean(touched && error);
  const showLabel = Boolean(label);

  return (
    <Flex
      direction="column"
      className={classNames(style.wrap, className, {
        [style.error]: showError,
      })}
    >
      {showLabel && <Label label={String(label)} htmlFor={id} />}
      <textarea
        id={id}
        className={classNames(style.input, {[style.error]: showError})}
        {...restProps}
      />
      {showError && <Text resetMargin text={error} type="error" />}
      {showHelp && <span className={style.help}>{helpText}</span>}
    </Flex>
  );
}
